<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout row wrap>
                <v-flex xs12>
                        <h2 style="font-family: Lato; margin-left: 10px">
                            <span style="color: white">
                                <span class="capitalLetter">F</span>ind</span>
                            <span style="color: white">
                                <span class="capitalLetter">W</span>orking</span>
                            <span style="color: white">
                                <span class="capitalLetter">P</span>arts</span>
                            <span style="color: white">
                                <span class="capitalLetter">I</span>n</span>
                            <span style="color: white">
                                <span class="capitalLetter">W</span>arehouses</span>
                        </h2>
                        <v-spacer></v-spacer>
                        <WarehouseStockTable              
                            v-if="!isLoading"
                            :warehouses="warehouses"
                            :is-loading="isLoading" 
                        />
                        <v-spacer>
                            <v-progress-circular v-if="isLoading" indeterminate color="primary"></v-progress-circular>
                        </v-spacer>
                </v-flex>
                <v-flex xs12>
                    <hr style="margin-top: 30px; margin-bottom: 30px; margin-left: 10px; margin-right: 10px">
                </v-flex>
                <v-flex xs12>
                        <h2 style="font-family: Lato; margin-left: 10px">
                            <span style="color: white">
                                <span class="capitalLetter">F</span>ind</span>
                            <span style="color: white">
                                <span class="capitalLetter">D</span>amaged</span>
                            <span style="color: white">
                                <span class="capitalLetter">P</span>arts</span>
                            <span style="color: white">
                                <span class="capitalLetter">I</span>n</span>
                            <span style="color: white">
                                <span class="capitalLetter">W</span>arehouses</span>
                        </h2>
                        <v-spacer></v-spacer>
                        <WarehouseStockTable              
                            v-if="!isLoading"
                            :warehouses="damagedWarehouses"
                            :is-loading="isLoading" 
                        />
                        <v-spacer>
                            <v-progress-circular v-if="isLoading" indeterminate color="primary"></v-progress-circular>
                        </v-spacer>
                </v-flex>
                <v-flex xs12>
                    <hr style="margin-top: 30px; margin-bottom: 30px; margin-left: 10px; margin-right: 10px">
                </v-flex>
                <v-flex xs12>
                    <v-card :elevation="20">
                        <h2 style="font-family: Lato; margin-left: 10px">
                            <span style="color: white">
                                <span class="capitalLetter">F</span>ind</span>
                            <span style="color: white">
                                <span class="capitalLetter">Q</span>uantity</span>
                            <span style="color: white">
                                <span class="capitalLetter">O</span>f</span>
                            <span style="color: white">
                                <span class="capitalLetter">P</span>art</span>
                            <span style="color: white">
                                <span class="capitalLetter">A</span>t</span>
                            <span style="color: white">
                                <span class="capitalLetter">W</span>arehouses</span>
                        </h2>
                        <v-card-text>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-autocomplete :items="part_name_list" v-model="partName" label="Parts" placeholder="Select..." required outline></v-autocomplete>
                            </v-form>
                        </v-card-text>
                    </v-card>
                    <div v-if="partNameSelected">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search2" append-icon="search" label=" Search" single-line outline hide-details>
                        </v-text-field>
                        <v-data-table :headers="headers_subco" :items="subco_list" :search="search2" :pagination.sync="pagination2" item-key="wh_name" class="elevation-1">
                            <template slot="items" slot-scope="props">
                                <tr @click="props.expanded = !props.expanded">
                                    <td>{{ props.item.wh_name }} </td>
                                    <td class="text-xs-right"> {{ props.item.qty }} </td>
                                </tr>
                            </template>
                            <template slot="no-data">
                                <v-spacer>
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </v-spacer>
                            </template>
                        </v-data-table>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>


<script>
const axios = require("axios");
import getSitePass from "../sitepass";
import WarehouseStockTable from "../components/tables/warehouseStockTable.vue"

export default {
  name: "subcotable",
  components: { WarehouseStockTable},
  data: function() {
    return {
      pagination2: {
        sortBy: "wh_name"
      },
      warehouses: [],
      damagedWarehouses: [],
      search2: "",
      headers_subco: [
        {
          text: "Warehouse",
          value: "wh_name"
        },
        {
          text: "Quantity",
          value: "qty"
        }
      ],
      props: {
        source: String
      },
      isLoading: true,
      valid: true,
      loadingPage: true,
      part_name_list: [],
      subco_list: [],
      partName: '',
      partList: { "0": {} },
      partNameSelected: false,
    };
  },
  watch: {
    partName(newValue, oldValue) {
      if (newValue === oldValue) {
        return
      }
      this.getAllWarehouses();
    },
  },
  computed: {
    warehouse_list: function() {}
  },
  methods: {
    getWarehouseStock() {
        Promise.all([this.getWorkingStock(),this.getDamagedStock()])
        .then(response => {
          this.warehouses = response[0].data;
          this.damagedWarehouses = response[1].data;
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getWorkingStock() {
        return axios
        .get(process.env.VUE_APP_backend_url + "/getWorkingWarehouseStock", {
          params: {
            sitepass: getSitePass()
          }
        })
    },
    getDamagedStock() {
        return axios
        .get(process.env.VUE_APP_backend_url + "/getDamagedWarehouseStock", {
          params: {
            sitepass: getSitePass()
          }
        })
    },
    getPartNames() {
      //
      axios
        .get(process.env.VUE_APP_backend_url + "/getPartNames", {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.part_name_list = response.data;
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => (this.loadingPage = false));
    },
    getAllWarehouses() {
      axios
        .get(process.env.VUE_APP_backend_url + "/getSubcoItemQtyList", {
          params: {
            part_name: this.partName,
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.subco_list = response.data;
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          this.partNameSelected = true;
        });
    },
    initialize() {
      this.getWarehouseStock();
      this.getPartNames();
    }
  },
  created() {
    this.initialize();
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/subcontractorStockView.vue